import { Button, Container, Grid, Typography } from "@material-ui/core";
import { Settings } from "@material-ui/icons";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";
import PaymentIcon from "@material-ui/icons/Payment";
import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import { API } from "../Constants/APIs";
export default class Setting extends Component {
  state = {
    planName: "",
    purchasedDate: "",
    nextBillingDate: "",
    amount: "",
    nodatafound: false,
    cardNumber: "",
    cardNumber2: "",
    gateway: "",
    card_type: "",
    customer_id: "",
    paymentSetting: false,
  };
  componentDidMount() {
    axios.get(API.getUrls.getPlans).then((resp) => {
      // console.log(resp);
      // console.log(resp.data.orders.docs.length);
      if (resp.data.orders.docs.length > 0) {
        var date = new Date(
          resp.data.orders.docs.at(
            -1
          ).order_summary.content.subscription.next_billing_at
        );
        var nextBillingDate = date.toString();
        // console.log(date);
        this.setState({
          planName:
            resp.data.orders.docs.at(-1).order_summary.content.subscription
              .subscription_items[0].item_price_id,
          purchasedDate: resp.data.orders.docs.at(-1).createdAt.slice(0, 10),
          nextBillingDate: nextBillingDate,
          amount:
            resp.data.orders.docs.at(-1).order_summary.content.subscription
              .subscription_items[0].amount,
          cardNumber:
            resp.data.orders.docs.at(-1).order_summary.content.card.iin,
          cardNumber2:
            resp.data.orders.docs.at(-1).order_summary.content.card.last4,
          gateway:
            resp.data.orders.docs.at(-1).order_summary.content.card.gateway,
          card_type:
            resp.data.orders.docs.at(-1).order_summary.content.card.card_type,
          customer_id:
            resp.data.orders.docs.at(-1).order_summary.content.card.customer_id,
        });
      } else {
        this.setState({
          nodatafound: true,
        });
      }
    });
  }

  logout = () => {
    localStorage.clear();
    window.location.href = "/sign-in";
  };

  showPaymentSetting = () => {
    this.setState({
      paymentSetting: true,
    });
  };
  render() {
    return (
      <Container className="containerSpacingdashBoard" maxWidth={"lg"}>
        <Grid container spacing={2} className="userDashboard">
          <Grid item sm={2} className="sidebar">
            <Sidebar />
          </Grid>
          <Grid
            item
            sm={10}
            style={{
              paddingLeft: window.innerWidth < 1000 ? "75px" : "105px",
              marginTop: "35px",
            }}
          >
            <Link
              to="/userprofile"
              style={{ textDecoration: "none", color: "#666666" }}
            >
              <Button
                className="profileBtn"
                style={{ width: window.innerWidth < 1000 ? "330px" : "405px" }}
              >
                <ArrowBackRoundedIcon
                  style={{
                    marginRight: window.innerWidth < 1000 ? "8px" : "15px",
                    marginLeft: window.innerWidth < 1000 ? "-2px" : "-13px",
                  }}
                />
                Profile
              </Button>
            </Link>

            <Button
              className="profileBtn"
              style={{ width: window.innerWidth < 1000 ? "330px" : "405px" }}
              onClick={this.showPaymentSetting}
            >
              <span style={{ marginRight: "30px" }}>
                {" "}
                <Settings className="personIcon" />
              </span>{" "}
              Payment Settings
            </Button>
            {this.state.paymentSetting ? (
              <>
                {/* <Typography className="representTitle">
                  <PaymentIcon className="userIcon" />Payment Settings
                </Typography> */}
                <Grid
                  item
                  sm={10}
                  style={{
                    marginLeft: window.innerWidth < 1000 ? "75px" : "15px",
                    marginTop: "35px",
                  }}
                >
                  {this.state.nodatafound ? (
                    "No Data Found."
                  ) : (
                    <div className="detailBack">
                      <Grid container spacing={2}>
                        {/* <Grid item sm={12}> */}
                        <Grid item sm={6}>
                          <h4>Plan Details</h4>
                        </Grid>
                        <Grid item sm={6}>
                          <a
                            href="javascript:void(0)"
                            data-cb-type="portal"
                            style={{ textDecoration: "none" }}
                          >
                            <Button
                              className="cancelPlanBtn"
                              style={{
                                width:
                                  window.innerWidth < 1000 ? "150px" : "150px",
                                position: "relative",
                                left: "200px",
                                top: "10px",
                              }}
                              onClick={this.showPaymentSetting}
                            >
                              Cancel Plan
                            </Button>
                          </a>
                        </Grid>
                        {/* </Grid> */}

                        <Grid item sm={4}>
                          <h5 className="infoItemPlan">Plan name</h5>
                          <Typography className="infoItemPlanDetail">
                            {this.state.planName}
                          </Typography>
                        </Grid>
                        <Grid item sm={4}>
                          <h5 className="infoItemPlan">Purchased Date</h5>
                          <Typography className="infoItemPlanDetail">
                            {this.state.purchasedDate}
                          </Typography>
                        </Grid>
                        <Grid item sm={4}>
                          <h5 className="infoItemPlan">Total Amount</h5>
                          <Typography className="infoItemPlanDetail">
                            ${this.state.amount}
                          </Typography>
                        </Grid>
                        {/* <Grid item sm={4}>
                        <h5 className="infoItemPlan">Next Billing Date</h5>
                        <Typography className="infoItemPlanDetail">{this.state.nextBillingDate}</Typography>
                      </Grid> */}

                        <Grid item sm={12}>
                          <h4>Card Details</h4>
                        </Grid>

                        <Grid item sm={4}>
                          <h5 className="infoItemPlan">Card Number</h5>
                          <Typography className="infoItemPlanDetail">
                            {this.state.cardNumber + this.state.cardNumber2}
                          </Typography>
                        </Grid>
                        <Grid item sm={4}>
                          <h5 className="infoItemPlan">Card Type</h5>
                          <Typography className="infoItemPlanDetail">
                            {this.state.card_type}
                          </Typography>
                        </Grid>
                        {/* <Grid item sm={4}>
                        <h5 className="infoItemPlan">Gateway</h5>
                        <Typography className="infoItemPlanDetail">{this.state.gateway}</Typography>
                      </Grid> */}
                        <Grid item sm={4}>
                          <h5 className="infoItemPlan">Customer Id</h5>
                          <Typography className="infoItemPlanDetail">
                            {this.state.customer_id}
                          </Typography>
                        </Grid>
                        {/* <Grid item sm={4}>
                        <h5 className="infoItemPlan">Hosted Models</h5>
                        <Typography className="infoItemPlanDetail">50 Hosted Models</Typography>
                      </Grid>
                      <Grid item sm={4}>
                        <h5 className="infoItemPlan">Monthly Views</h5>
                        <Typography className="infoItemPlanDetail">80,000 Monthly Website Views</Typography>
                      </Grid> */}
                      </Grid>
                    </div>
                  )}
                </Grid>
              </>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Container>
    );
  }
}
